<template>
  <div class="footer bg-dark text-white" :class="{ hidden: isHidden, 'in-iframe' : isIframe, 'scrolling': !visible, 'visible': visible }" :style="footerStyle" ref="bar">
    <div class="container">
      <div v-if="model" class="big pull-left d-none d-lg-block">
        {{ model.fullname }}
      </div>
      <div class="btn-group-responsive pull-right mb-1">
        <button class="btn btn-success btn-sm" @click="onOffer()">Richiedi un'offerta</button>
        <button class="btn btn-success btn-sm" @click="onEmail()">Invia per email</button>
      </div>
      <div class="pull-right big mr-3">
        <currency :value="configuration.price"></currency> <small>(+ IVA)</small>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  @import "~bootstrap/scss/bootstrap";
  @import "../../../sass/common/mixins";

  .footer {
    position: fixed;
    display: block;
    bottom: 0;
    // height: 80px;
    left: 0;
    width: 100%;
    padding: 15px;

    @include media-breakpoint-up(md) {
      display: none !important;
    }

    .btn-group-responsive {
      @include media-breakpoint-down(sm) {
        width: 100%;
        .btn {
          width: 100%;
          margin-bottom: 3px;
        }
      }
    }

    &.in-iframe {
      position: absolute;
      bottom: inherit;
      top: 0;
    }

    .container {
      line-height: 30px;
    }

    &.hidden {
      display: none;
    }

    &.scrolling {
      @include opacity(0);
    }

    &.visible {
      -webkit-animation: display-in 0.15s; /* Safari 4+ */
      -moz-animation:    display-in 0.15s; /* Fx 5+ */
      -o-animation:      display-in 0.15s; /* Opera 12+ */
      animation:         display-in 0.15s; /* IE 10+, Fx 29+ */
    }

    .big {
      font-size: 2rem;
    }

    small {
      font-size: 1rem;
      position: relative;
      top: -0.3rem;
    }
  }

  @-webkit-keyframes display-in {
    0%   { opacity: 0; }
    100% { opacity: 1; }
  }
  @-moz-keyframes display-in {
    0%   { opacity: 0; }
    100% { opacity: 1; }
  }
  @-o-keyframes display-in {
    0%   { opacity: 0; }
    100% { opacity: 1; }
  }
  @keyframes display-in {
    0%   { opacity: 0; }
    100% { opacity: 1; }
  }
</style>

<script>
    import IframeEventsMixin from '../mixins/IframeEvents'
    export default {
        mixins: [ IframeEventsMixin ],

        props: {
          configuration: {
            type: Object,
            required: true
          }
        },

        data: function() {
          return {
            scrollY: 0,
            model: null,
            showCb: null,
            visible: true,
            scrolling: false,
          }
        },

        created: function() {
          this.onMessageBinding = this.onMessage.bind(this);
          window.addEventListener('message', this.onMessageBinding);

          this.$watch('configuration.model', () => {
            this.model = this.configuration.model;
          })

          this.$watch('configuration.price', () => {
            this.sendEvent({
                type: 'priceChange',
                price: this.configuration.price
            })
          })
        },

        destroyed() {
          window.removeEventListener('message', this.onMessageBinding);
        },

        computed: {
          isIframeVisible() {
            return this.isIframe && this.visible
          },

          isHidden() {
            return this.configuration.price <= 0;
          },

          isIframe() {
            return window.top != window;
          },

          footerStyle() {
            return this.isIframe ? { top: this.scrollY + 'px' } : {};
          },
        },

        methods: {
          onOffer() {
            this.$events.$emit('request-offer', this.configuration);
          },

          onEmail() {
            this.$events.$emit('send-email', this.configuration);
          },

          onMessage(event) {
            if (event.data.type == "scrollParent") {
              let scrollY = Math.min(
                event.data.scrollY + event.data.height - this.$refs.bar.offsetHeight,
                window.innerHeight - this.$refs.bar.offsetHeight
              );

              if(scrollY != this.scrollY) {
                this.scrollY = scrollY;
                this.visible = false;
                if (this.showCb) {
                  clearTimeout(this.showCb);
                }
                this.showCb = setTimeout(() => {
                  this.visible = true
                }, 150);
              }

            }
          }
        }
    }
</script>
